class ContentClassificationActions {
  constructor() {
    this.generateActions(
      'updateContentClassificationSuccess', 'updateContentClassificationFail'
    );
  }

  updateAppContentClassification(contentClassification) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          this.updateContentClassificationSuccess('app', contentClassification);
        } catch (error) {
          this.updateContentClassificationFail({ error });
        }
      });
  }

  updatePrimaryContentSourceContentClassification(contentClassification) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          this.updateContentClassificationSuccess('primaryContentSource', contentClassification);
        } catch (error) {
          this.updateContentClassificationFail({ error });
        }
      });
  }

  updateRouteContentClassification(contentClassification) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          this.updateContentClassificationSuccess('route', contentClassification);
        } catch (error) {
          this.updateContentClassificationFail({ error });
        }
      });
  }

}

export default ContentClassificationActions;



// WEBPACK FOOTER //
// ./app/flux/actions/ContentClassification.js